import { Container } from "@mui/material";
import { CenterBoxLayout } from "./CenterLayout.style";
import React from "react";

const CenterLayout = ({
  children,
  noPadding,
}: {
  children: React.ReactNode;
  noPadding?: boolean;
}) => {
  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100dvh",
      }}
    >
      <CenterBoxLayout sx={{ boxShadow: 3, padding: noPadding ? 0 : "10%" }}>
        {children}
      </CenterBoxLayout>
    </Container>
  );
};

export default CenterLayout;
